import { FEATURE, getCrudRoles, getViewRoles } from 'constants/feature'
import { USER_ROLE } from 'constants/user-role'

export type PermissionAction = 'view' | 'crud'

/**
 * Single source of truth for role-based access. Super Admin bypass lives here
 * and nowhere else — guards and components must not special-case it.
 */
export const checkPermission = (
  role: USER_ROLE | null,
  feature: FEATURE,
  action: PermissionAction
): boolean => {
  if (!role) return false
  if (role === USER_ROLE.SUPER_ADMIN) return true

  const allowed = action === 'view' ? getViewRoles(feature) : getCrudRoles(feature)
  return allowed.includes(role)
}
